import { useMemo } from 'react';
import { Tooltip } from '@ds';
import { EmployeeRole } from '@/api/apis/resources';
import { BASE_MULTI_CASE_SUGGEST_ROLES } from '@/permissions';
import { getRoleNames } from '@/utils/helpers';

type MultiSuggestEmployeeRoleListProps = {
  roles: EmployeeRole[];
};

export const MultiSuggestEmployeeRoleList = ({ roles }: MultiSuggestEmployeeRoleListProps) => {
  const rolesList = useMemo(() => {
    const mainRoles = roles.filter((r) => BASE_MULTI_CASE_SUGGEST_ROLES.includes(r));

    return getRoleNames(mainRoles);
  }, [roles]);

  const [mainRole, ...additionalRoles] = rolesList;

  return (
    <Tooltip
      placement="top"
      className="max-w-64"
      isDisabled={!additionalRoles.length}
      content={rolesList.join(', ')}
      key="additionalRolesCount"
      closeDelay={0}
    >
      <div className="flex items-center gap-1 truncate">
        <span className="text-s-r text-base-20">{mainRole}</span>
        {!!additionalRoles.length && <span className="text-s-r text-base-20">+{additionalRoles.length}</span>}
      </div>
    </Tooltip>
  );
};
